// extracted by mini-css-extract-plugin
export default {"navigation":"ys2_k"};